import {
  Tooltip,
  Card,
  Typography,
  Input,
  Button,
  Switch,
  Pagination,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SortingArrow from "../../Common/SortingArrow";

import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { checkPermissionAction } from "../../utils/helper/utils";
import ZonesPolygons from "../../Modal/ZonePolygons";
let timer = null;

const ManageZones = () => {
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(0);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedPolygons, setEditedPolygons] = useState([]);
  const mapInstanceRef = useRef(null);
  const mapRef = useRef(null);

  const navigate = useNavigate();
  const { Search } = Input;
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const scriptRef = useRef(null);
  const polygonsRef = useRef([]);
  const overlaysRef = useRef([]);
  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_ZONE?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Zone deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllZone();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllZone = useCallback(async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_ZONE.GET_ALL_ZONES,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  },[dispatch, inputData, paginationModel?.limit, paginationModel?.page]);

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllZone();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_ZONE?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Zone active successfully";
        if (item.status === "active") msg = "Zone inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllZone();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const clickOnClick = async (id, name) => {
    localStorage.setItem("zoneName", name);
    navigate(`/zone/timeslots-holidays/` + id);
  };

  const enablePolygonEditing = (polygonMeta) => {
    polygonsRef.current.forEach((meta) =>
      meta.polygon.setEditable(meta.zoneId === polygonMeta.zoneId)
    );
  };

  const cleanupPolygonsAndLabels = () => {
    polygonsRef.current.forEach((meta) => {
      try {
        meta.pathListeners?.forEach((l) =>
          window.google.maps.event.removeListener(l)
        );
        meta.polygon.setMap(null);
      } catch (_) {}
    });
    polygonsRef.current = [];
    overlaysRef.current.forEach((overlay) => {
      try {
        overlay.setMap(null);
      } catch (_) {}
    });
    overlaysRef.current = [];
  };

  const toLatLngObjects = (coords) =>
  coords.map(([lat, lng]) => ({ lat: Number(lat), lng: Number(lng) }));

  const createLabelOverlay = (map, centroid, text) => {
    const labelDiv = document.createElement("div");
    Object.assign(labelDiv.style, {
      fontWeight: "bold",
      textAlign: "center",
      color: "#000",
      background: "rgba(255, 255, 255, 0.8)",
      padding: "2px 6px",
      borderRadius: "4px",
      whiteSpace: "nowrap",
      userSelect: "none",
    });
    labelDiv.innerHTML = text;

    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function () {
      this.getPanes().overlayLayer.appendChild(labelDiv);
    };
    overlay.draw = function () {
      const projection = this.getProjection();
      if (!projection) return;
      const position = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(centroid.lat, centroid.lng)
      );
      if (position) {
        labelDiv.style.position = "absolute";
        labelDiv.style.left = `${position.x - labelDiv.offsetWidth / 2}px`;
        labelDiv.style.top = `${position.y - labelDiv.offsetHeight / 2}px`;
      }
    };
    overlay.onRemove = function () {
      labelDiv.remove();
    };
    overlay.setMap(map);

    overlaysRef.current.push(overlay);
    return overlay;
  };

  const onPathChange = (zoneId, polygon) => {
    const updatedCoords = polygon.getPath().getArray().map(pt => ({
      lat: pt.lat(),
      lng: pt.lng()
    }));

    setEditedPolygons(prevZones => {
      const existingIndex = prevZones.findIndex(z => z.id === zoneId);
      if (existingIndex !== -1) {
        const updated = [...prevZones];
        updated[existingIndex] = { id: zoneId, coordinates: updatedCoords };
        return updated;
      } else {
        return [...prevZones, { id: zoneId, coordinates: updatedCoords }];
      }
    });
  };

  const initMap = useCallback(() => {
    if (!mapRef.current) return;

    cleanupPolygonsAndLabels();

    const defaultCenter = { lat: 24.7136, lng: 46.6753 };
    const map = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 12,
      mapTypeId: "roadmap",
      streetViewControl: false,
      mapTypeControl: false,
    });
    mapInstanceRef.current = map;
    const bounds = new window.google.maps.LatLngBounds();

    (list || [])
      .filter((zone) => zone.status === "active")
      .forEach((zone) => {
        const coords = zone?.coordinates?.coordinates?.[0] || [];
        const polygonCoords = toLatLngObjects(coords).filter(
          ({ lat, lng }) =>
            lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
        );
        if (!polygonCoords.length) return;

        polygonCoords.forEach((pt) => bounds.extend(pt));

        const polygon = new window.google.maps.Polygon({
          paths: polygonCoords,
          strokeColor: "#007aaf",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#00ccff",
          fillOpacity: 0.35,
          editable: false,
          zIndex: 1,
        });
        polygon.setMap(map);
        const centroid = polygonCoords.reduce(
          (acc, { lat, lng }) => ({
            lat: acc.lat + lat / polygonCoords.length,
            lng: acc.lng + lng / polygonCoords.length,
          }),
          { lat: 0, lng: 0 }
        );

        createLabelOverlay(map, centroid, zone.name || "Zone");
        const meta = {
          zoneId: zone.id,
          polygon,
          zone,
          pathListeners: [],
        };
        polygonsRef.current.push(meta);

        polygon.addListener("click", () => enablePolygonEditing(meta));

        ["set_at", "insert_at", "remove_at"].forEach((evt) => {
          meta.pathListeners.push(
            window.google.maps.event.addListener(
              polygon.getPath(),
              evt,
              () => {
                console.log(`Path change event: ${evt} for zone ${zone.id}`);
                onPathChange(zone.id, polygon);
              }
            )
          );
        });
      });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds, 50);
    }
  },[list]);

  useEffect(() => {
    if (isModalOpen) getAllZone();
  }, [isModalOpen, getAllZone]);

  useEffect(() => {
    if (isModalOpen && window.google && window.google.maps && mapRef.current) {
      initMap();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  useEffect(() => {
    if (!isModalOpen) return;
    if (!window.google && !scriptRef.current) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDPV2HCRku3C8x4bqMczeatcoc87P9SS28&libraries=drawing`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (mapRef.current) {
          initMap();
        }
      };
      document.head.appendChild(script);
      scriptRef.current = script;
    } else {
        if (isModalOpen && window.google && window.google.maps && mapRef.current) {
          initMap();
        }
      }
    return () => {
      cleanupPolygonsAndLabels();
    };
  }, [isModalOpen, list, initMap]);

  const saveEdits = async () => {
    try {
      const updates = editedPolygons.filter(z => z.id && z.coordinates?.length);
      if (!updates.length) return toast?.info?.("No changes to save");

      const payload = updates.map(({ id: zoneId, coordinates }) => ({
        id: zoneId,
        coordinates: 
          coordinates.map(({ lat, lng }) => [lat, lng]),
      }));

     const apiResponse = await globalRequest?.(
        `${Apis.MANAGE_ZONE.UPDATE_ZONE_POLYGONS}`,
        "put",
        { payload },
        {},
        true
      );
      if ( apiResponse?.data?.status === "SUCCESS" ) {
        let msg = "Zone polygons updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
          handleCancel();
      }
      await getAllZone();
      setEditedPolygons([]);
      if (window.google && mapRef.current) initMap();

    } catch (error) {
      toast?.error?.(error?.message || "Failed to save zone edits");
    }
  };

  return (
    <>
      <Card>
        <div className="flex flex-wrap justify-between items-center mb-4 gap-3 w-full">
          <div className="">
            <Typography className="text-xl font-semibold">
              Manage Zone
            </Typography>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Button 
              type="primary" 
              onClick={showModal}
              className="cursor-pointer"
            >
              View Zone
            </Button>
            <Search
              placeholder="Search by zone name"
              onSearch={onSearch}
              style={{
                width: 250,
              }}
              className="cursor-pointer"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            {checkPermissionAction("Zones", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="cursor-pointer"
                onClick={() => navigate("/add-zone")}
              >
                Add Zone
              </Button>
            ) : null}
          </div>
          <ZonesPolygons permissionJson ={permissionJson} handleCancel={handleCancel} isModalOpen={isModalOpen} saveEdits={saveEdits} mapRef={mapRef}/>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Name{" "}
                  <SortingArrow onSort={(order) => handleSort("name", order)} />
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap"
                >
                  Timeslot and Holidays
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item.name}
                    </td>
                    <td className="px-3 py-4 vertical-top text-center">
                      {checkPermissionAction(
                        "Zone specific Timeslots & Holidays",
                        permissionJson,
                        "view"
                      ) ? (
                        <span
                          onClick={() => {
                            clickOnClick(item.id, item.name);
                          }}
                          className="hover:text-[#1677ff] text-[#1677ff] text-underline cursor-pointer"
                        >
                          Click
                        </span>
                      ) : null}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Zones",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Zones",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/edit-zone/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Zones",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Zones",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Zones",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this Zone?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};
export default ManageZones;
